import { Plus } from "lucide-react";

type InsertionPointButtonProps = {
  section: "procedures" | "diagnoses";
  index: number;
  onClick: () => void;
};

export function InsertionPointButton({ section, index, onClick }: InsertionPointButtonProps) {
  const isProcedure = section === "procedures";
  const colorClasses = isProcedure
    ? "bg-blue-500 hover:bg-blue-600 focus-visible:ring-blue-400"
    : "bg-green-600 hover:bg-green-700 focus-visible:ring-green-400";
  const label = isProcedure ? "Insert procedure here" : "Insert diagnosis here";

  return (
    <div
      className="flex items-center py-0.5 group"
      role="separator"
      data-testid={`insertion-point-${section}-${index}`}
    >
      <div className="flex-1 h-px bg-gray-200 group-hover:bg-gray-300 transition-colors" />
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={`mx-1 h-5 w-5 rounded-full flex items-center justify-center text-white shadow-sm transition-all ${colorClasses} opacity-60 hover:opacity-100 hover:scale-110 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1`}
      >
        <Plus className="h-3 w-3" strokeWidth={3} />
      </button>
      <div className="flex-1 h-px bg-gray-200 group-hover:bg-gray-300 transition-colors" />
    </div>
  );
}
